/**
 * Firm field character limits
 * Used across firm creation and edit validations
 */
export const FIRM_FIELD_LIMITS = {
  FIRM_NAME: 70,
  ADDRESS_LINE: 35,
  CITY: 35,
  ZIP: 10,
};
